// extracted by mini-css-extract-plugin
export var burgerized = "PageLinksStyle-module--burgerized--a444a";
export var currentPage = "PageLinksStyle-module--currentPage--2f1ad";
export var pageLink = "PageLinksStyle-module--pageLink--5aee3";